import * as React from "react";
import { Container, Breadcrumb, BreadcrumbItem, Button } from "reactstrap";
import { Link } from "react-router-dom";
import { bindActionCreators, compose } from "redux";
import { connect } from "react-redux";
import ReactTable from "react-table";
import "react-table/react-table.css";

import { orderConstants } from "../../_constants";
import { ordersAction } from "../../_actions";
import { Loading } from "../Loading";
import { PayOrderModal } from "./PayOrderModal";
import { withTranslation } from "react-i18next";

class OrderListState extends React.Component<any, any> {
  constructor(props: any) {
    super(props);

    this.state = {
      items: [],
      value: "",
      filtered: []
    };
  }

  componentDidMount() {
    this.props.load();
  }

  componentDidUpdate(prevProps: any) {
    if (
      this.props.orders.loading != prevProps.orders.loading &&
      this.props.orders.loading
    ) {
      this.props.load();
    }
  }

  onFilteredChangeCustom(value: any, accessor: any) {
    let filtered = this.state.filtered;
    let insertNewFilter = 1;

    if (filtered.length) {
      filtered.forEach((filter: any, i: any) => {
        if (filter["id"] === accessor) {
          if (value === "" || !value.length) filtered.splice(i, 1);
          else filter["value"] = value;

          insertNewFilter = 0;
        }
      });
    }

    if (insertNewFilter) {
      filtered.push({ id: accessor, value: value });
    }

    this.setState({ filtered: filtered });
  }

  formatDate(date: any, lang: any) {
    let day = date.slice(8, 10);
    let month = date.slice(5, 7);
    let year = date.slice(0, 4);
    switch (lang) {
      case "cs":
        day = day[0] == 0 ? day[1] : day;
        month = month[0] == 0 ? month[1] : month;
        return day + ". " + month + ". " + year;
      default:
        return month + "/" + day + "/" + year;
    }
  }

  isOnlinePayment(isOnline: boolean) {
    if (this.state.locales == "cs") {
      return isOnline ? "Ano" : "Ne";
    }
    if (this.state.locales == "en") {
      return isOnline ? "Yes" : "No";
    }
  }

  canPay(id: any) {
    if (id == orderConstants.ORDER_ID_CANCELED) {
      if (this.isAdmin()) {
        return true;
      } else {
        return false;
      }
    }
    if (id == orderConstants.ORDER_ID_PAID) {
      return false;
    }
    return true;
  }

  isAdmin() {
    const { authentication } = this.props;
    let admin = false;

    authentication &&
      (authentication.user &&
        (authentication.user.roles &&
          authentication.user.roles.map((role: any) => {
            role == "Admin" && (admin = true);
          })));

    return admin;
  }

  orderStateColor(id: any) {
    if (id == orderConstants.ORDER_ID_CANCELED) return "red";
    if (id == orderConstants.ORDER_ID_PAID) return "green";

    return "#6c757d";
  }

  getPaymentValue(val: any) {
    switch(val){
      case "online":
        return "online"
      case "offline":
        return "offline"
      default:
        return "vse"
    }
  }
  render() {
    const { orders, t } = this.props;
    const lang = localStorage.getItem("i18nextLng");

    if (orders.loading || orders.data == []) {
      return <Loading />;
    }

    return (
      <>
        <Container>
          <Breadcrumb>
            <BreadcrumbItem>
              <Link to="/">Sypal</Link>
            </BreadcrumbItem>
            <BreadcrumbItem active>{t('order_list')}</BreadcrumbItem>
          </Breadcrumb>
          <ReactTable
            data={orders.data}
            filterable
            minRows={0}
            filtered={this.state.filtered}
            pageSizeOptions={[10, 20, 30, 50, 100, 200, 500, 1000]}
            onFilteredChange={(filtered: any, column: any, value: any) => {
              this.onFilteredChangeCustom(value, column.id || column.accessor);
            }}
            defaultFilterMethod={(filter: any, row: any, column: any) => {
              const id = filter.pivotId || filter.id;
              if (typeof filter.value === "object") {
                return row[id] !== undefined
                  ? filter.value.indexOf(row[id]) > -1
                  : true;
              } else {
                return row[id] !== undefined
                  ? String(row[id]).indexOf(filter.value) > -1
                  : true;
              }
            }}
            previousText={t('table_controls.previous')}
            nextText={t('table_controls.next')}
            loadingText={t('table_controls.loading')}
            noDataText={t('table_controls.no_rows_found')}
            pageText={t('table_controls.page')}
            ofText={t('table_controls.of')}
            rowsText={t('table_controls.rows')}
            columns={[
              {
                Header: t("variable_symbol"),
                accessor: "variableSymbol",
                width: 90,
                style: { margin: "auto" }
              },
              {
                Header: t("company_name"),
                accessor: "address.companyName",
                style: { margin: "auto" },
                Cell: (cellInfo: any) => {
                  return (
                    <Link
                      className="detail-link"
                      to={"order-detail/" + cellInfo.original.id}> {cellInfo.original.address.companyName}</Link>
                  )
                }
              },
              {
                Header: t("name"),
                accessor: "licenceType.name",
                style: { margin: "auto" }
              },
              {
                Header: t("system"),
                accessor: "licenceType.systemInfo.name",
                width: 60,
                style: { margin: "auto" }
              },
              {
                Header: t("created"),
                accessor: "created",
                style: { margin: "auto" },
                Cell: (cellInfo: any) => {
                  return (
                    <div>{this.formatDate(cellInfo.original.created, lang)}</div>
                  );
                },
                width: 100
              },
              {
                Header: t("payment"),
                accessor: "onlinePayment",
                width: 100,
                style: {textAlign: "center", margin: "auto"},
                Cell: (cellInfo: any) => cellInfo.original.onlinePayment ? "online" : "offline",
                filterMethod: (filter :any, row :any) => {
                  if (filter.value == "all") {
                    return true;
                  }
                  return row[filter.id] == filter.value;
                },
                Filter: ({ filter, onChange }: any) => {
                  return (
                    <select
                      onChange={e => onChange(e.target.value)}
                      style={{ width: "100%" }}
                      value={filter ? filter.value : "all"}
                    >
                      <option value="all">{t("orderState.all")}</option>
                      <option value="1">online</option>
                      <option value="0">offline</option>
                    </select>
                  );
                }
              },
              {
                Header: t("state"),
                accessor: "orderState",
                id: "state",
                style: {
                  textAlign: "center",
                  fontWeight: "bold",
                  textTransform: "uppercase",
                  fontSize: "0.8rem",
                  margin: "auto"
                },
                Cell: (cellInfo: any) => (
                  <span
                    style={{
                      color: this.orderStateColor(
                        cellInfo.original.orderStateId
                      )
                    }}
                  >
                    {lang == "en"
                      ? cellInfo.original.orderStateLocalized
                      : cellInfo.original.orderState}
                  </span>
                ),
                filterMethod: (filter: any, cellInfo: any) => {
                  if (filter.value.includes("all")) {
                    return true;
                  }

                  if (filter.value.includes(cellInfo._original.orderStateId))
                  {
                    return true;
                  }

                  return false;
                },
                Filter: ({ filter, onChange }: any) => {
                  return (
                    <select
                      onChange={(event: any) => {
                        let selectedOptions = [].slice
                          .call(event.target.selectedOptions)
                          .map((o: any) => {
                            return o.value;
                          });

                        this.onFilteredChangeCustom(selectedOptions, "state");
                      }}
                      style={{ width: "100%" }}
                      value={filter ? filter.value[0] : "all"}
                      // multiple={true}
                    >
                      <option value="all">{t('orderState.all')}</option>
                      <option value={orderConstants.ORDER_ID_CREATED}>{t('orderState.created')}</option>
                      <option value={orderConstants.ORDER_ID_PAID}>{t('orderState.paid')}</option>
                      <option value={orderConstants.ORDER_ID_CANCELED}>{t('orderState.canceled')}</option>
                      <option value={orderConstants.ORDER_ID_WAITING}>{t('orderState.waiting')}</option>
                    </select>
                  );
                }
              },
              {
                Header: t("price"),
                accessor: "price",
                width: 120,
                style: { margin: "auto" },
                Cell: (cellInfo: any) => {
                  return (
                    <div>
                      {cellInfo.original.price} {cellInfo.original.currency}
                    </div>
                  );
                }
              },
              {
                Header: t("table_actions"),
                accessor: "actions",
                filterable: false,
                width: 108,
                maxWidth: 108,
                style: { margin: "auto" },
                Cell: cellInfo => (
                  <div style={{ justifyContent: "center", display: "flex" }}>
                    {this.canPay(cellInfo.original.orderStateId) ? (
                      <PayOrderModal
                        buttonLabel="Pay order"
                        id={cellInfo.original.id}
                        variableSymbol={cellInfo.original.variableSymbol}
                        currency={cellInfo.original.currency}
                        price={cellInfo.original.price}
                        name={cellInfo.original.licenceType.name}
                        style={{ padding: ".25rem .5rem" }}
                        canceled={
                          cellInfo.original.orderStateId ==
                          orderConstants.ORDER_ID_CANCELED
                        }
                        icon={true}
                      />
                    ) : (
                      <Button
                        style={{
                          backgroundColor: "rgb(214, 230, 218)",
                          borderColor: "rgb(208, 230, 213)"
                        }}
                        disabled
                      >
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
                        <path fill="#ffffff" d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1.41 16.09V20h-2.67v-1.93c-1.71-.36-3.16-1.46-3.27-3.4h1.96c.1 1.05.82 1.87 2.65 1.87 1.96 0 2.4-.98 2.4-1.59 0-.83-.44-1.61-2.67-2.14-2.48-.6-4.18-1.62-4.18-3.67 0-1.72 1.39-2.84 3.11-3.21V4h2.67v1.95c1.86.45 2.79 1.86 2.85 3.39H14.3c-.05-1.11-.64-1.87-2.22-1.87-1.5 0-2.4.68-2.4 1.64 0 .84.65 1.39 2.67 1.91s4.18 1.39 4.18 3.91c-.01 1.83-1.38 2.83-3.12 3.16z"/>
                        <path fill="none" d="M0 0h24v24H0z"/>
                        </svg>

                      </Button>
                    )}

                    <Link to={`order-detail/${cellInfo.original.id}`}>
                      <Button style={{ marginLeft: "5px" }}>
                      <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
                      <path d="M0 0h24v24H0z" fill="none"/>
                      <path fill="#ffffff" d="M19 19H5V5h7V3H5c-1.11 0-2 .9-2 2v14c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2v-7h-2v7zM14 3v2h3.59l-9.83 9.83 1.41 1.41L19 6.41V10h2V3h-7z"/>
                      </svg>
                      </Button>
                    </Link>
                  </div>
                )
              }
            ]}
            className="-striped -highlight"
          />
        </Container>
      </>
    );
  }
}

const mapStateToProps = (state: any) => {
  return {
    orders: state.orders,
    authentication: state.authentication
  };
};

const mapDispatchToProps = (dispatch: any) => {
  return bindActionCreators(
    {
      load: ordersAction.loadOrders
    },
    dispatch
  );
};

const OrderListComponent = compose (
    withTranslation('orders'),
    connect(mapStateToProps, mapDispatchToProps)
  )(OrderListState)

export { OrderListComponent as OrderList };
